import React from 'react';
import g from 'glamorous';

import {
  normalMargin,
  largeMargin,
  largeBreakpoint
} from '../utils/layout-units';

export default g.div({
  margin: normalMargin,
  [`@media (min-width: ${largeBreakpoint})`]: {
    margin: largeMargin,
  },
});



// WEBPACK FOOTER //
// ./src/components/responsive-margin.js